<template>
<div ref="popupContainer" >
    <!-- <vs-popup
    :title="idEdit? 'Misé a jour: ' + thisThema.name : 'Nouveau Thématique'"
    :active.sync="isPopupActive">
    <NetlinkThemaPopup :isPopupActive="isPopupActive" :thematique="thisThema" :isEdit="idEdit" @close-thema-popup="closethemaPopup()"/>
    </vs-popup> -->
    <vs-popup
    :title="'Supprimer: ' + thisThema.name"
    :active.sync="isValidationPopupActive">
	<div style="display:flex; justify-content: space-around;">
		<vs-button @click="isPopupActive=false"> Non</vs-button>
		<vs-button @click="deleteThema()" color="danger"> Oui</vs-button>
	</div>
    </vs-popup>

      <vs-table
        max-items="20"
        stripe
        :data="netlinkThemaList"
      >
        <template slot="thead">
          <vs-th class="th-sticky" style="width: 50px !important; text-align: center;">Thématique</vs-th>
          <vs-th class="th-sticky" style="width: 50px; text-align: center;">Plateforme<br/>Média Référent</vs-th>
          <vs-th class="th-sticky" style="width: 50px; text-align: center;">Plateforme<br/>Article Sponsorisé </vs-th>
          <vs-th class="th-sticky" style="width: 50px; text-align: center;">Plateforme<br/>Lien HP</vs-th>
          <vs-th class="th-sticky" style="width: 50px; text-align: center;">Régie<br/>Article Sponsorisé</vs-th>
          <vs-th class="th-sticky" style="width: 50px; text-align: center;">Régie<br/>Média Référent</vs-th>
          <vs-th class="th-sticky" style="width: 50px; text-align: center;">Éditeur<br/>Média Référent</vs-th>
          <vs-th class="th-sticky" style="width: 50px; text-align: center;">Éditeur<br/>Article Sponsorisé</vs-th>
          <!-- <vs-th>Type de pres style="width: 50px; text-align: center;"tation</vs-th> -->
          <vs-th class="th-sticky" style="width: 50px; text-align: center;" v-if="$acl.check('admin')"></vs-th>
          <vs-th class="th-sticky" style="width: 50px; text-align: center;" v-if="$acl.check('sadmin')"></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="index" v-for="(tr, index) in data">
			<!-- <div v-show="false">
				{{setRowNum(data.length)}}
			</div> -->

            <vs-td style="text-align: center;">{{ tr.name }}</vs-td>
            <vs-td style="text-align: center;">{{ tr.pmr }}%</vs-td>
            <vs-td style="text-align: center;">{{ tr.pas }}%</vs-td>
            <vs-td style="text-align: center;">{{ tr.plh }}%</vs-td>
            <vs-td style="text-align: center;">{{ tr.ras }}%</vs-td>
            <vs-td style="text-align: center;">{{ tr.rmr }}%</vs-td>
            <vs-td style="text-align: center;">{{ tr.emr }}%</vs-td>
            <vs-td style="text-align: center;">{{ tr.eas }}%</vs-td>
            <!-- <vs-td>{{ getNetlinkName(tr.is_netlink) }}</vs-td> -->
            <vs-td v-if="$acl.check('admin')" style="text-align: center;">
              <vx-tooltip text="Modifier" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
                <vs-button
                    size="large"
                    color="primary"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-edit-2"
                    @click="displayEditPopup(tr)"
                ></vs-button>
              </vx-tooltip>
            </vs-td>
            <vs-td v-if="$acl.check('sadmin')" style="text-align: center;">
				<vx-tooltip text="Effacer" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
					<vs-button
						size="large"
						color="danger"
						type="flat"
						icon-pack="feather"
						icon="icon-trash-2"
						@click="displayValidationPopup(tr)"
					></vs-button>
				</vx-tooltip>
        </vs-td>
          </vs-tr>
        </template>
      </vs-table>
</div>
</template>
<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import NetlinkThemaPopup from "@/components/popups/NetlinkThemaPopup";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/plugins/monthSelect/style.css";

export default {
	name: "NetlinkThemaTable",
	components: {
		NetlinkThemaPopup
		/*
		 * PurchaseForm,
		 * NetlinkTable,
		 * PurchasesTable,
		 * flatPickr
		 */
	},
	props: {

	},
	mixins: [dbFieldConvertor, utilsMixin],
	data() {
		return {
			idEdit: true,
			isPopupActive: false,
			isValidationPopupActive: false,
			apiUrl: this.$store.state.backendApiUrl,
			thisThema: {}
		};
	},
	created() {
		store.dispatch("getAllNetlinkThemaList");
	},
	mounted() {



	},
	watch: {

	},
	computed: {
		netlinkThemaList: () => {
			return store.state.netlinkThemas;
		}
	},
	methods: {
		displayEditPopup(tr){
			// this.idEdit = true;
			// this.thisThema = tr;
			// this.isPopupActive = true;
			this.$emit("edit-popup", tr);
		},
		closethemaPopup(){
			this.isPopupActive = false;
		},
		addnewThema(){
			this.idEdit = false;
			this.isPopupActive = true;
		},
		displayValidationPopup(tr){
			this.isValidationPopupActive = true;
			this.thisThema = tr;
		},
		async deleteThema(){
			try{
				await this.$http.delete(this.apiUrl + "netlink/thema/del/"+ this.thisThema.id);
				this.$vs.notify({
					title: "Succès",
					text: "Thématique supprimé avec succès."
				});
				this.isValidationPopupActive = false;
				store.dispatch("getAllNetlinkThemaList");

			}
			catch(err){
				this.$vs.notify({
					title: "Echec",
					text: "Error " + err.toString()
				});
			}
		}
	}};
</script>